import React, { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Input from 'react-phone-number-input/input';

import './index.css';
import gameimg from '../../assets/images/gameimg.png';
import biglogo from '../../assets/images/biglogo.png';
import message from '../../assets/images/message.svg';
import phone from '../../assets/images/phone.svg'
import lock from '../../assets/images/lock.svg';
import facebook from '../../assets/images/facebook.svg';
import google from '../../assets/images/google.svg';
import apple from '../../assets/images/apple.svg';
import hide from '../../assets/images/hide.svg';
import showEye from '../../assets/images/showeye.png'

import { loginAct, playDemoAct } from '../../store/actions/authActions';

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { token, loading, error } = useSelector((state) => state.auth);

    const [formData, setFormData] = useState({})
    const [showStatus, setShowStatus] = useState(true);

    // Redirect to the index route after successful login
    useEffect(() => {
        if (token) {
            navigate('/'); // Redirect to the index route or desired page
        }
        dispatch(playDemoAct(false));
    }, [token, navigate]);

    const handleChange = (e, prop) => {
        let inputData = { ...formData }
        inputData[prop] = e && e.target ? e.target.value : e;
        setFormData(inputData);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(loginAct(formData));
        navigate('/login')
    };

    const handleShowStatus = () => {
        setShowStatus(!showStatus)
    }

    console.log(formData['email'], 'phone number')
    return (
        <>
            <div className='screen-1-section'>
                <div className='screen-1-content'>
                    <div className='screen-gameimgpart'>
                        <div className='screen-gameimage'>
                            <img src={gameimg} alt="gameimg" className='img-fluid' />
                        </div>
                        <div className='screen-logo-part'>
                            <div className='screen-1-logo-image'>
                                <Link to="/landing">
                                    <img src={biglogo} alt="logo" className='img-fluid' />
                                </Link>
                            </div>
                            <div className='screen-1-main-title'>
                                <h3>BallHog</h3>
                            </div>
                        </div>
                    </div>
                    <div className='screen-form'>
                        <Form>
                            <Form.Group controlId="formGroupEmail" className='form-group'>
                                <Input
                                    country="US"
                                    international
                                    withCountryCallingCode
                                    value={formData['email']}
                                    className='form-control'
                                    onChange={(e) => handleChange(e, 'email')}
                                />
                                {/* <Form.Control type="tel" placeholder="Phone Number" onChange={(e) => handleChange(e, 'email')} value={formData['email']} /> */}
                                <img src={phone} alt="phone" className='img-fluid' />
                            </Form.Group>
                            <Form.Group controlId="formGroupPassword" className='form-group' onChange={(e) => handleChange(e, 'password')} value={formData['password']}>
                                <Form.Control type={showStatus ? "password" : "text"} placeholder="Password" />
                                <img src={lock} alt="lock" className='img-fluid' />
                                <img src={showStatus ? hide : showEye} alt="hide" className='hide-password' onClick={handleShowStatus} />
                            </Form.Group>
                            <Link to='/screen2'>
                                <Button type="submit" className='sign-in-btn' onClick={handleSubmit}>SIGN IN</Button>
                            </Link>
                            <div className='foregt-password-block'>
                                <Link to="/forgotPassword" className='forget-password'>Forgot Password?</Link>
                            </div>
                        </Form>
                        {/* <span className='devider'>or continue with</span> */}
                        {/* <div className='continue-signin-group'>
                            <Button target='_blank'><img src={facebook} alt="facebook" className='img-fluid' /></Button>
                            <Button target='_blank'><img src={google} alt="facebook" className='img-fluid' /></Button>
                            <Button target='_blank'><img src={apple} alt="facebook" className='img-fluid' /></Button>
                        </div> */}
                        <div className='sign-up-block'>
                            <p>Don't have an account? <Link to="/register">Sign up</Link></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Login
